import React, { useState } from 'react';

const ShareButton = () => {
  const [showModal, setShowModal] = useState(false);
  const [copySuccess, setCopySuccess] = useState('');
  const currentUrl = window.location.href;

  const handleShare = async () => {
    const shareData = {
      title: 'Job Opportunity at Maxiom Wealth',
      url: currentUrl
    };

    // 1. Try Web Share API
    if (navigator.share && typeof navigator.share === 'function') {
      try {
        await navigator.share(shareData);
        setCopySuccess('Link shared successfully!');
        setTimeout(() => setCopySuccess(''), 2000);
        return;
      } catch (error) {
        setCopySuccess('Sharing was cancelled or failed.');
        setTimeout(() => setCopySuccess(''), 2000);
      }
    }

    // 2. Try Clipboard API
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      try {
        await navigator.clipboard.writeText(currentUrl);
        setCopySuccess('Link copied to clipboard!');
        setTimeout(() => setCopySuccess(''), 2000);
        return;
      } catch (err) {
        // Continue to next fallback
      }
    }

    // 3. Try execCommand (legacy)
    const textArea = document.createElement('textarea');
    textArea.value = currentUrl;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        setCopySuccess('Link copied to clipboard!');
        setTimeout(() => setCopySuccess(''), 2000);
        document.body.removeChild(textArea);
        return;
      }
    } catch (err) {
      // Continue to modal
    }
    document.body.removeChild(textArea);

    // 4. Show modal for manual copy
    setShowModal(true);
  };

  const handleManualCopy = () => {
    const textArea = document.createElement('textarea');
    textArea.value = currentUrl;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      setCopySuccess('Link copied to clipboard!');
      setShowModal(false);
      setTimeout(() => setCopySuccess(''), 2000);
    } catch (err) {
      setCopySuccess('Please copy the link manually.');
    }
    document.body.removeChild(textArea);
  };

  return (
    <>
      <button
        className="p-2 rounded-full bg-slate-100 hover:bg-slate-200 transition-colors"
        aria-label="Share"
        onClick={handleShare}
        type="button"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
        </svg>
      </button>
      {/* Feedback message */}
      {copySuccess && (
        <div style={{ position: 'fixed', top: 20, right: 20, background: '#e2e8f0', color: '#334155', padding: '8px 16px', borderRadius: 8, zIndex: 1000 }}>
          {copySuccess}
        </div>
      )}
      {/* Modal fallback */}
      {showModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', padding: 24, borderRadius: 12, minWidth: 300, boxShadow: '0 4px 32px rgba(0,0,0,0.2)' }}>
            <h2 style={{ marginBottom: 8 }}>Share this job</h2>
            <input
              type="text"
              value={currentUrl}
              readOnly
              style={{ width: '100%', marginBottom: 12, padding: 8, border: '1px solid #cbd5e1', borderRadius: 4 }}
              onFocus={e => e.target.select()}
            />
            <button onClick={handleManualCopy} style={{ marginRight: 8, background: '#64748b', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 4 }}>
              Copy
            </button>
            <button onClick={() => setShowModal(false)} style={{ background: '#e2e8f0', color: '#334155', border: 'none', padding: '8px 16px', borderRadius: 4 }}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ShareButton;